/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Purchase_Itunes_StoreInputs */

const en_mobile_benefits_purchase_itunes_store = /** @type {(inputs: Mobile_Benefits_Purchase_Itunes_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase appears as "ITUNES STORE"`)
};

const es_mobile_benefits_purchase_itunes_store = /** @type {(inputs: Mobile_Benefits_Purchase_Itunes_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La compra aparece como "ITUNES STORE"`)
};

/**
* | output |
* | --- |
* | "Purchase appears as \"ITUNES STORE\"" |
*
* @param {Mobile_Benefits_Purchase_Itunes_StoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_purchase_itunes_store = /** @type {((inputs?: Mobile_Benefits_Purchase_Itunes_StoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Purchase_Itunes_StoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_purchase_itunes_store(inputs)
	return en_mobile_benefits_purchase_itunes_store(inputs)
});